import type { TextProps } from 'react-native'
import * as C from './product-header-title.styles'

export const ProductHeaderTitle = (props: TextProps) => {
  const { children, testID } = props
  const titleProps = {
    numberOfLines: 2,
  }
  return (
    <C.Title {...titleProps} testID={testID}>
      {children}
    </C.Title>
  )
}
